import React from 'react';

const SubmittedIcon = (props) => (
  <svg width="84" height="84" viewBox="0 0 84 84" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M42 0C18.8421 0 0 18.8421 0 42C0 65.1579 18.8421 84 42 84C65.1579 84 84 65.1579 84 42C84 18.8421 65.1579 0 42 0ZM65.4737 30.9474L38.6316 57.5789C37.0526 59.1579 34.5263 59.2632 32.8421 57.6842L18.6316 44.7368C16.9474 43.1579 16.8421 40.5263 18.3158 38.8421C19.8947 37.1579 22.5263 37.0526 24.2105 38.6316L35.4737 48.9474L59.4737 24.9474C61.1579 23.2632 63.7895 23.2632 65.4737 24.9474C67.1579 26.6316 67.1579 29.2632 65.4737 30.9474Z" fill="#1369E9" />
  </svg>

);
export default SubmittedIcon;
